import React, { memo } from 'react';
import styled from 'styled-components';
import { receptionStaffTableHeader as headers } from '../config';
import { formatDate } from '@shared/utils/common';
import type { ReceptionStaffItem } from '../types/types';

type ReceptionStaffTableProps = {
	staffs: ReceptionStaffItem[];
};

// 리셉션 상세 - 부스·담당자 처리 현황
const ReceptionStaffTable = memo<ReceptionStaffTableProps>(({ staffs }) => {
	return (
		<Wrapper>
			<HeaderRow>
				{headers.map(header => (
					<HeaderCell key={header.label} $minWidth={header.minWidth} $width={header.width}>
						{header.label}
					</HeaderCell>
				))}
			</HeaderRow>
			{staffs.map(staff => (
				<BodyRow key={staff.staffId}>
					<BodyCell $minWidth={headers[0].minWidth} $width={headers[0].width}>
						{staff.name}
					</BodyCell>
					<BodyCell $minWidth={headers[1].minWidth} $width={headers[1].width}>
						{staff.processedCount.toLocaleString()}
					</BodyCell>
					<BodyCell $minWidth={headers[2].minWidth} $width={headers[2].width}>
						{staff.qrCount.toLocaleString()}
					</BodyCell>
					<BodyCell $minWidth={headers[3].minWidth} $width={headers[3].width}>
						<ManualCount>{staff.manualCount.toLocaleString()}</ManualCount>
					</BodyCell>
					<BodyCell $minWidth={headers[4].minWidth} $width={headers[4].width}>
						{formatDate(staff.changedAt, 'YYYY. MM. DD HH:mm')}
					</BodyCell>
				</BodyRow>
			))}
		</Wrapper>
	);
});

ReceptionStaffTable.displayName = 'ReceptionStaffTable';

export default ReceptionStaffTable;

const Wrapper = styled.div`
	width: 100%;
	max-width: 680px;
`;
const HeaderRow = styled.div`
	height: 44px;
	display: flex;
	align-items: center;
	border-top: 1px solid ${({ theme }) => theme.colors.ultraLightGrayBorder};
	border-bottom: 1px solid ${({ theme }) => theme.colors.ultraLightGrayBorder};
`;
const HeaderCell = styled.div<{ $minWidth: number; $width: number }>`
	min-width: ${({ $minWidth }) => $minWidth}px;
	width: ${({ $width }) => $width}%;
	${({ theme }) => theme.typography.body2};
	color: ${({ theme }) => theme.colors.deepGrayFontColor};
`;
const BodyRow = styled.div`
	height: 48px;
	display: flex;
	align-items: center;
	border-bottom: 1px solid ${({ theme }) => theme.colors.ultraLightGrayBorder};
`;
const BodyCell = styled.div<{ $minWidth: number; $width: number }>`
	min-width: ${({ $minWidth }) => $minWidth}px;
	width: ${({ $width }) => $width}%;
	${({ theme }) => theme.typography.body2};
	color: ${({ theme }) => theme.colors.blackColor};
`;
const ManualCount = styled.span`
	color: ${({ theme }) => theme.colors.activeRedOrange};
`;
